import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/internal/Observable';
import { GenericService } from '../../commons/generic.service';
import { environment } from 'environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ArquivoBlobDTO } from "../../model/arquivoBlob.dto";

@Injectable()
export class DadosAuxilioTransporte extends GenericService {

    private basePath = 'api/v1';
    private path = '/auxilio-transporte';
    url = environment.url;

    constructor(http: HttpClient) {
        super(http);
    }

    getVerificaSeOUsuarioTemAuxilio(): Observable<any> {
        return this.http.get<any>(this.url + this.basePath + this.path + '/verifica');
    }

    getNumeroPercurso(): Observable<any> {
        return this.http.get<any>(this.url + this.basePath + this.path + '/numero-percurso');
    }
    
    getLinhasViculadasAoUsuario(pagina: number, tamanho: number): Observable<any> {
        return this.http.get<any>(this.url + this.basePath + this.path + `/pagina/${pagina}/tamanho/${tamanho}`);
    }

    getArquivo(): Observable<ArquivoBlobDTO> {
        const options = {
            responseType: 'blob' as 'json'
        };
        return this.http.get<ArquivoBlobDTO>(this.url + this.basePath + '/visualizar_comprovante' + this.path, options);
    }

    excluirLinha(codgLinha): Observable<any> {
        const headers = new HttpHeaders({
            'Content-Type': 'application/json'
        })
        const body = {
            codgLinha: [codgLinha]
        };
        return this.http.post(this.url + this.basePath + this.path + '/excluir-linha', body, { headers });
    }

    getTodasLinhasTransporte(pagina, tamanho, filtro): Observable<any> {
        const começaComNúmero = /^\d/.test(filtro);
        let params = {
            descLinha: filtro,
            codgLinhaPref: ''
        };
        if (começaComNúmero == false) {
            params.descLinha = filtro
            params.codgLinhaPref = ''
        } else {
            params.descLinha = ''
            params.codgLinhaPref = filtro
        }
        return this.http.get<any>(this.url + this.basePath + '/linha' + `/pagina/${pagina}/tamanho/${tamanho}`, { params: params });
    }

    atualizarEndereco(data): Observable<any> {
        return this.http.patch(this.url + this.basePath + this.path, data);
    }

    veriUsuarioTemAuxilio(data): Observable<any> {
        return this.http.post(this.url + this.basePath + this.path + '/salvar-linha', data);
    }

    salvar(codgLinha: number[], numePercurso: number): Observable<any> {
        const body = {
            codgLinha: codgLinha,
            numePercurso: Number(numePercurso)
        };
        return this.http.post(this.url + this.basePath + this.path + '/salvar-linha', body);
    }
}
